import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ExternalSystemsSelectDropdownComponent } from '../dropdown/external-systems-select-dropdown.component';
import { select } from '@ngrx/store';

@Component({
    selector: 'app-external-systems-select',
    templateUrl: './external-systems-select.component.html',
    styleUrls: ['./external-systems-select.component.scss'],
})
export class ExternalSystemsSelectComponent implements OnInit {
    @Input() label: string;
    @Input() placeholder: string;
    @Input() connector: any;

    @Input()
    get selected() {
        return this.connector;
    }
    set selected(data) {
        this.connector = data;
    }

    @ViewChild(ExternalSystemsSelectDropdownComponent)
    public dropdown: ExternalSystemsSelectDropdownComponent;

    @Input() options: any[];
    @Output() selectChange = new EventEmitter();

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit() {
        this.cdr.detectChanges();
    }

    select(option: any) {
        this.selected = option;
        this.selectChange.emit(this.selected);
        this.hideDropdown();
    }

    public toggleDropdown(): void {
        this.dropdown.showing ? this.hideDropdown() : this.showDropdown();
    }

    public showDropdown() {
        this.dropdown.show();
    }

    public hideDropdown() {
        this.dropdown.hide();
    }

    public onTouched: () => void = () => {};
    public OnChange: () => void = () => {};

    writeValue(obj: any): void {
        this.selected = obj;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
}
